export { default } from "@/components/technology/TechnologyBrandLogo";
export type { TechnologyBrandLogoId as TechnologyPartnerLogoId } from "@/components/technology/TechnologyBrandLogo";
